import { mapGetters } from 'vuex'
import { types as STORE_MODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'
import axios from '@/js/helper/axios-helper.js'
import {
  HUBSPOT_INSTANCE_ID,
  HUBSPOT_FORM_MAPPING,
  HUBSPOT_SUBJECT_TRANSLATIONS,
} from '@/js/components/HubSpot/Helpers/hubspot-constants.js'

export default {
  data() {
    return {
      fetching: false,
      defaultBrand: 'FOCUS_SANDBOX',
    }
  },
  computed: {
    ...mapGetters(STORE_MODULES.APP, {
      hubspotMiddlewareFormApi: APP_GETTER.HUBSPOT_MIDDLEWARE_FORM_API,
      messagingDomain: APP_GETTER.MESSAGING_DOMAIN,
      locale: APP_GETTER.LOCALE,
    }),
    hubspotInstanceId() {
      const brand = this.selectedBrand || this.defaultBrand
      return HUBSPOT_INSTANCE_ID[brand]
    },
    hubspotFormId() {
      if (this.hubspotInstanceId && HUBSPOT_FORM_MAPPING[this.hubspotInstanceId]) {
        const form = HUBSPOT_FORM_MAPPING[this.hubspotInstanceId].forms
        const matchingForm = form.find(f => f.name === this.component)

        if (matchingForm) {
          return matchingForm.id
        }
      }

      return null
    },
    messagingApiUnauthenticated() {
      return 'https://' + this.messagingDomain + '/api/form_submissions_unauthenticated'
    },
  },
  methods: {
    translateSubjects(subject, locale) {
      const translation =
        subject &&
        locale &&
        HUBSPOT_SUBJECT_TRANSLATIONS[subject] &&
        HUBSPOT_SUBJECT_TRANSLATIONS[subject][locale]
          ? HUBSPOT_SUBJECT_TRANSLATIONS[subject][locale]
          : subject
      return translation
    },
    async submitCallback(postData) {
      if (!postData || this.fetching) return
      this.showSuccessMessage = false
      this.showGeneralErrorMessage = false

      this.fetching = true

      const { data, files = undefined } = postData

      if (!data) return
      var prefix = null
      Object.keys(data['fields']).forEach(v => {
        //if optional customsubject is set prefix gets value of the customsubject
        if (data['fields'][v].name == 'customsubject' && data['fields'][v].value) {
          prefix = data['fields'][v].value.toString()
        }
        //translation for subject if language is not english
        if (data['fields'][v].name == 'subject') {
          if (this.locale !== 'en') {
            data['fields'][v].value = this.translateSubjects(data['fields'][v].value, this.locale)
          }
          if (prefix) {
            data['fields'][v].value = prefix + ' | ' + data['fields'][v].value
          }
        }
      })
      let indexOfCustomSubject = data['fields'].findIndex(obj => obj.name === 'customsubject')
      if (indexOfCustomSubject !== -1) {
        // Remove custom subject object from data fields
        data['fields'].splice(indexOfCustomSubject, 1)
      }
      const additionalData = {
        hubspotFormId: this.hubspotFormId,
        hubspotInstanceId: this.hubspotInstanceId,
        formName: this.component,
        userIsLoggedIn: this.userIsLoggedIn,
      }

      data['additionalData'] = additionalData

      let formData = new FormData()
      if (files) {
        if (files.length) {
          files.forEach(file => {
            if (file.value) {
              formData.append('files[' + file.key + ']', file.value)
            }
          })
        }
      }

      formData.append('data', JSON.stringify(data))
      formData.append('_method', 'put')

      const url = this.hubspotMiddlewareFormApi ?? this.messagingApiUnauthenticated
      axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          this.fetching = false
          this.showSuccessMessage = true
          Object.keys(this.$refs.dynamicForm.$data).forEach(v => {
            if (typeof this.$refs.dynamicForm.$data[v] == 'boolean') {
              this.$refs.dynamicForm.$data[v] = false
            } else if (typeof this.$refs.dynamicForm.$data[v] == 'string') {
              this.$refs.dynamicForm.$data[v] = ''
            } else {
              this.$refs.dynamicForm.$data[v] = null
            }
          })
          Object.keys(this.$refs.descriptionForm.$data).forEach(
            v => (this.$refs.descriptionForm.$data[v] = null),
          )
          this.$refs.dynamicForm.resetValidation()
          this.$refs.descriptionForm.resetValidation()
          console.warn(response)
        })
        .catch(error => {
          this.fetching = false
          this.showGeneralErrorMessage = true
          console.error(error)
        })
    },
  },
}
